<template>
  <div class="admin-wrapper">
    <div class="admin-table-header">
      <el-input placeholder="Please input" v-model="searchString" class="input-with-select">
        <template slot="prepend">Поиск</template>
        <el-button @click="resetSearchString" slot="append" icon="el-icon-close"></el-button>
      </el-input>
      <el-button @click="openCreateDialog" type="primary">Добавить пункт</el-button>
    </div>
    <div class="admin-table-wrapper">
      <el-table
          v-loading="loading"
          class="admin-table"
          :data="filteredList"
          stripe>
        <el-table-column
            prop="id"
            label="#"
            width="60">
        </el-table-column>
        <el-table-column
            class-name="small"
            prop="name_ru"
            label="Русский"
            >
        </el-table-column>
        <el-table-column
            class-name="small"
            prop="name_kz"
            label="Казахский"
            >
        </el-table-column>
        <el-table-column
            class-name="small"
            prop="name_en"
            label="Английский"
            >
        </el-table-column>
        <el-table-column
            label="Операции"
            width="130"
            fixed="right">
          <template #default="scope">
            <edit-btn :id="scope.row.id" :show="true" />
            <delete-btn :id="scope.row.id" :show="true"/>
          </template>
        </el-table-column>
      </el-table>
      <create-dialog />
      <edit-dialog />
    </div>
  </div>
</template>
<script>
import formSettings from '@/mixins/formSettings'
import CreateDialog from '@/components/FormSettings/CreateDialog'
import DeleteBtn from '@/components/FormSettings/DeleteBtn'
import EditBtn from '@/components/FormSettings/EditBtn'
import EditDialog from '@/components/FormSettings/EditDialog'

export default {
  components: {CreateDialog, DeleteBtn, EditBtn, EditDialog},
  mixins: [formSettings],
  data(){
    return {
      loading: false,
    }
  },
  mounted(){
    this.category = 'social_status'
    this.loading = true
    this.loadList().then(() => setTimeout(() => this.loading = false, 100))
  }
}
</script>